import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { AuthState } from 'models'

const getInitialAuthState = (): AuthState => {
  try {
    const tokenRaw = localStorage.getItem('access_token')
    const userIdRaw = localStorage.getItem('user_id')
    const token = tokenRaw ? JSON.parse(tokenRaw) : null
    const userId = userIdRaw ? JSON.parse(userIdRaw) : 0

    if (token && userId) {
      return {
        user_id: userId,
        isLogged: true,
        balance: {
          coinMare: '',
          coinEmas: ''
        }
      }
    }
  } catch (e) {
    // ignore parse errors
  }

  return {
    user_id: 0,
    isLogged: false,
    balance: {
      coinMare: '',
      coinEmas: ''
    }
  }
}

const initialState: AuthState = getInitialAuthState()

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthState: (_, action: PayloadAction<AuthState>) => {
      return action.payload
    },

    logout: () => {
      return {
        user_id: 0,
        isLogged: false,
        balance: {
          coinMare: '',
          coinEmas: ''
        }
      }
    }
  }
})

export const { setAuthState, logout } = authSlice.actions

export default authSlice.reducer
